// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ank7","newExpiryDate":"styles_newExpiryDate__2C4Xx","footer":"styles_footer__2IMoE"};